import { clone } from '@jack-henry/frontend-utils/functions';
import { formatUsdCurrency } from '@treasury/utils';
import { format } from 'date-fns';

interface TransactionReportItem {
    accountType: string;
    checkImageNumber: string;
    checkNumber: string;
    description: string;
    accountNumber: string;
    accountName: string;
    debits: number | null;
    debitAmount: number | null;
    isDebit: boolean;
    credits: number | null;
    creditAmount: number | null;
    balance: number | null;
    splitTransactions: null;
    transactionCode: string;
    transactionCodeDescription: string;
    data?: DateRangeTransactionReportItem[];
}
export interface DateRangeTransactionReportItem extends TransactionReportItem {
    date: string;
}

const nullTransactionReportItem: TransactionReportItem = {
    accountNumber: '',
    accountName: '',
    accountType: '',
    checkImageNumber: '',
    description: '',
    checkNumber: '',
    debitAmount: 0,
    isDebit: false,
    // eslint-disable-next-line no-restricted-syntax
    debits: null,
    // eslint-disable-next-line no-restricted-syntax
    credits: null,
    creditAmount: 0,
    balance: 0,
    // eslint-disable-next-line no-restricted-syntax
    splitTransactions: null,
    transactionCode: '',
    transactionCodeDescription: '',
};

export class TransactionReportItemVm {
    constructor(private dto = clone(nullTransactionReportItem)) {}

    public createDefault() {
        return new TransactionReportItemVm(this.dto);
    }

    public get isTransaction() {
        return true;
    }

    public get accountNumber() {
        return this.dto.accountNumber;
    }

    public get accountName() {
        return this.dto.accountName;
    }

    public get accountType() {
        return this.dto.accountType;
    }

    public get checkImageNumber() {
        return this.dto.checkImageNumber;
    }

    public get description() {
        return this.dto.description;
    }

    public get checkNumber() {
        return this.dto.checkNumber;
    }

    public get debitAmount() {
        return formatUsdCurrency(this.dto.debitAmount || 0);
    }

    public get isDebit() {
        return this.dto.isDebit;
    }

    public get creditAmount() {
        return formatUsdCurrency(this.dto.creditAmount || 0);
    }

    public get balance() {
        return formatUsdCurrency(this.dto.balance || 0);
    }

    public get splitTransactions() {
        return this.dto.splitTransactions;
    }

    public get transactionCode() {
        return this.dto.transactionCode;
    }

    public get transactionCodeDescription() {
        return this.dto.transactionCodeDescription;
    }

    public get data() {
        return this.dto.data?.map(item => ({
            date: item.date ? format(new Date(item.date || ''), 'P') : '',
            accountType: item.accountType,
            checkImageNumber: item.checkImageNumber,
            checkNumber: item.checkNumber,
            description: item.description,
            accountNumber: item.accountNumber,
            debits: item.debits
                ? formatUsdCurrency(item.debits || 0)
                : formatUsdCurrency(item.debitAmount || 0),
            isDebit: item.isDebit,
            credits: item.credits
                ? formatUsdCurrency(item.credits || 0)
                : formatUsdCurrency(item.creditAmount || 0),
            balance: formatUsdCurrency(item.balance || 0),
            splitTransactions: item.splitTransactions,
            transactionCodeDescription: item.transactionCodeDescription,
        }));
    }

    public get isDateRange() {
        return !!this.dto.data;
    }
}
